"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputAdorment = exports.InputAdornment = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var wrapAdornmentAddon = function (addon, classPrefix) { return (react_1.default.createElement("div", { className: classPrefix + "-input-group__addon" }, addon)); };
var wrapAdornmentText = function (text, pure, classPrefix) { return (react_1.default.createElement("span", { className: pure
        ? classPrefix + "-form__help-text--inline"
        : classPrefix + "-input-group__text" }, text)); };
exports.InputAdornment = forward_ref_with_statics_1.forwardRefWithStatics(function InputAdornment(_a, ref) {
    var before = _a.before, after = _a.after, children = _a.children, appearence = _a.appearence, _b = _a.appearance, appearance = _b === void 0 ? appearence : _b, className = _a.className, props = tslib_1.__rest(_a, ["before", "after", "children", "appearence", "appearance", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    if (typeof before === "string") {
        // eslint-disable-next-line no-param-reassign
        before = wrapAdornmentText(before, false, classPrefix);
    }
    if (typeof after === "string") {
        // eslint-disable-next-line no-param-reassign
        after = wrapAdornmentText(after, appearance === "pure", classPrefix);
    }
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-input-group", className) }, props),
        before && wrapAdornmentAddon(before, classPrefix),
        children,
        after && wrapAdornmentAddon(after, classPrefix)));
}, {
    defaultLabelAlign: "middle",
});
exports.InputAdornment.displayName = "InputAdornment";
/**
 * @deprecated
 *
 * 请使用 InputAdornment 代替
 */
exports.InputAdorment = exports.InputAdornment;
//# sourceMappingURL=InputAdornment.js.map